import React from "react";
import PhotoItem from './PhotoItem';
import './PhotoWall.css';

const PhotoWall = ({ photos }) => {
    return (
        <div className="photo-wall">
            {photos.map(photo => (
                // CREATES A NEW ELEMENT FOR THE NUMBER OF FILES IT'S GIVEN
                <PhotoItem key={photo.key} photo={photo} />
            ))}
        </div>
    )
};

export default PhotoWall;